import React from "react"
import "./index.css"

const PFP = props => (
  <div className={"pfp"}>
    <img
      src={`https://cdn.discordapp.com/avatars/${props.user.id}/${props.user.avatar}.jpg`}
      alt={props.user.username}
    />
    <p>{props.user.username}</p>
  </div>
)

export default PFP



// WEBPACK FOOTER //
// ./src/components/pfp/PFP.js